export function sortStringListOrderAscending(
  stringOne: string,
  stringTwo: string): number {
  if (stringOne > stringTwo) {
    return 1;
  } else if (stringOne < stringTwo) {
    return -1;
  }
  return 0;
}
